<template>
    <div @click="showDetail">
        <img :style="{
            'width': '100%',
            'height': '100%',
            'object-fit': objectFit,
        }" :src="url" />

        <div v-if="ifShowDetail" style="z-index: 999;position: fixed;left: 0;top: 0;width: 100%;height: 100%;background: #00000066;display: flex;align-items: center;" @click.stop.self="close">
            <img ref="bigImg" :src="url" style="position: relative;transform-origin: 50% 50%;margin: 0 2%;width: 96%;object-fit: contain;" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },

        detailUrl: {
            type: String,
            default: ""
        },

        objectFit: {
            type: String,
            default: "fill",
        },
    },

    data() {
        return {
            ifShowDetail: false,
        }
    },

    mounted()
    {
        
    },

    methods: {
        showDetail()
        {
            this.ifShowDetail = true;

            //
            setTimeout(() => {
                var store = {
                    scale: 1,
                    imgTranslateX: 0,
                    imgTranslateY: 0,
                    oneFingerOffsetX: 0,
                    oneFingerOffsetY: 0,
                };

                // 缩放事件的处理
                this.$refs.bigImg.addEventListener('touchstart', event => {
                    var touches = event.touches;
                    var events = touches[0];
                    var events2 = touches[1];

                    event.preventDefault();
                    
                    // 第一个触摸点的坐标
                    store.pageX = events.pageX;
                    store.pageY = events.pageY;

                    //
                    store.prePageX = events.pageX;
                    store.prePageY = events.pageY;

                    //
                    store.moveable = true;

                    if (events2) {
                        store.pageX2 = events2.pageX;
                        store.pageY2 = events2.pageY;
                    }

                    store.originScale = store.scale || 1;
                });

                document.addEventListener('touchmove', event => {
                    if (!store.moveable) {
                        return;
                    } 

                    event.preventDefault();
                    var touches = event.touches;
                    var events = touches[0];
                    var events2 = touches[1];

                    // 双指移动
                    if (events2) {
                        // 第2个指头坐标在touchmove时候获取
                        if (!store.pageX2) {
                            store.pageX2 = events2.pageX;
                        }
                        if (!store.pageY2) {
                            store.pageY2 = events2.pageY;
                        }

                        // 获取坐标之间的距离
                        var getDistance = function (start, stop) {
                            return Math.hypot(stop.x - start.x, stop.y - start.y);
                        };
                        // 双指缩放比例计算
                        var zoom = getDistance({
                            x: events.pageX,
                            y: events.pageY
                        }, {
                            x: events2.pageX,
                            y: events2.pageY
                        }) /
                        getDistance({
                            x: store.pageX,
                            y: store.pageY
                        }, {
                            x: store.pageX2,
                            y: store.pageY2
                        });
                        // 应用在元素上的缩放比例
                        var newScale = store.originScale * zoom;
                        // 最大缩放比例限制
                        if (newScale > 10) {
                            newScale = 10;
                        }
                        // 记住使用的缩放值
                        store.scale = newScale;
                        // 图像应用缩放效果
                        this.$refs.bigImg.style.transform = 'scale('+ newScale +')';
                    }
                    else
                    {
                        const imgClientRect = this.$refs.bigImg.getBoundingClientRect();

                        //
                        if(events.pageY - store.prePageY < 0)
                        {
                            console.log("up");
                        }
                        else
                        {
                            console.log("down");
                        }

                        if(events.pageX - store.prePageX < 0)
                        {
                            console.log("left");
                        }
                        else
                        {
                            console.log("right");
                        }

                        let ifStopXMove = false;
                        let ifStopYMove = false;

                        // 单指移动
                        if(events.pageY - store.prePageY < 0 && imgClientRect.top + imgClientRect.height <= 100)
                        {
                            console.log("********************************** up stop");

                            //
                            ifStopYMove = true;
                        }

                        if(events.pageY - store.prePageY > 0 && (innerHeight||document.documentElement.clientHeight||document.body.clientHeight) - imgClientRect.top <= 100)
                        {
                            console.log("********************************** down stop");

                            //
                            ifStopYMove = true;
                        }

                        if(events.pageX - store.prePageX < 0 && imgClientRect.left + imgClientRect.width <= 100)
                        {
                            console.log("********************************** left stop");

                            //
                            ifStopXMove = true;
                        }

                        if(events.pageX - store.prePageX > 0 && (innerWidth||document.documentElement.clientWidth||document.body.clientWidth) - imgClientRect.left <= 100)
                        {
                            console.log("********************************** right stop");

                            //
                            ifStopXMove = true;
                        }

                        //
                        if(!ifStopXMove)
                        {
                            store.oneFingerOffsetX = events.pageX - store.pageX;
                        }
                        
                        if(!ifStopYMove)
                        {
                            store.oneFingerOffsetY = events.pageY - store.pageY;
                        }

                        //
                        console.log("store.oneFingerOffsetX: " + store.oneFingerOffsetX);
                        console.log("store.oneFingerOffsetY: " + store.oneFingerOffsetY);

                        //
                        this.$refs.bigImg.style.translate = `${store.imgTranslateX + store.oneFingerOffsetX}px ${store.imgTranslateY + store.oneFingerOffsetY}px`;
                    }

                    //
                    store.prePageX = events.pageX;
                    store.prePageY = events.pageY;
                });

                document.addEventListener('touchend', event => {
                    //
                    if(store.moveable)
                    {
                        //
                        store.imgTranslateX += store.oneFingerOffsetX;
                        store.imgTranslateY += store.oneFingerOffsetY;

                        //
                        store.oneFingerOffsetX = 0;
                        store.oneFingerOffsetY = 0;
                    }

                    //
                    store.moveable = false;

                    //
                    delete store.pageX2;
                    delete store.pageY2;
                });

                document.addEventListener('touchcancel', () => {
                    //
                    if(store.moveable)
                    {
                        //
                        store.imgTranslateX += store.oneFingerOffsetX;
                        store.imgTranslateY += store.oneFingerOffsetY;

                        //
                        store.oneFingerOffsetX = 0;
                        store.oneFingerOffsetY = 0;
                    }

                    //
                    store.moveable = false;

                    delete store.pageX2;
                    delete store.pageY2;
                });
            }, 100);
        },

        doNothing()
        {

        },

        close()
        {
            this.ifShowDetail = false;
        },
    }
}
</script>

<style>

</style>